// extracted by mini-css-extract-plugin
module.exports = {"section":"OfferTransactionsList_section_3zix8","header":"OfferTransactionsList_header_1NDok","list":"OfferTransactionsList_list_3GVnq","date":"OfferTransactionsList_date_384j4"};